import usersallComponent from './users.all.component';

let usersallModule = angular.module('usersall', [
])
.run(['$rootScope', '$uibModalStack',
    function ($rootScope,  $uibModalStack) {       
        // close the opened modal on browser back button
        $rootScope.$on('$locationChangeStart', function ($event) {
            var openedModal = $uibModalStack.getTop();
            if (openedModal) {
                if (!!$event.preventDefault) {
                    $event.preventDefault();
                }
                if (!!$event.stopPropagation) {
                    $event.stopPropagation();
                }
                $uibModalStack.dismiss(openedModal.key);
                // window.history.back();
            }
        });
    }])
.component('usersall', usersallComponent)

.name;
export default usersallModule;


// WEBPACK FOOTER //
// ./client/app/components/users/all/index.js